import { BRAND } from "@/data/content";

export function BrandLogo({ location = "header" }) {
    return (
        <img
            className={`brand-logo brand-logo--${location}`}
            src={BRAND.logoUrl}
            alt="RESET365 — Votre propriété, notre priorité"
            loading={location === "header" ? "eager" : "lazy"}
            data-testid={`reset365-${location}-logo`}
        />
    );
}
